<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="control" (selectionChange)="selectionChanged.emit($event.value)">
    @if (allowNone()) {
      <mat-option value="">{{ noneLabel() }}</mat-option>
    }
    @for (item of options(); track item.id) {
      <mat-option [value]="item.id">{{ optionLabel(item) }}</mat-option>
    }
  </mat-select>
  @if (tooltip(); as text) {
    <mat-icon matSuffix class="mr-2 cursor-help" [matTooltip]="text">info</mat-icon>
  }
  @if (hint(); as text) {
    <mat-hint>{{ text }}</mat-hint>
  }
  @if (hasRequiredError()) {
    <mat-error>{{ requiredError() }}</mat-error>
  }
</mat-form-field>
